module.exports = __webpack_public_path__ + "static/media/notebook_and_pencils.8219131f.svg";